/* eslint-disable @typescript-eslint/no-empty-function */
import { usePermissions, useUpsertTaskGroup } from '@dispatch/shared/hooks';
import { TaskGroup } from '@dispatch/shared/types';
import { TaskGroupDetails } from '@dispatch/web/features/task-groups';
import { useNotificationMutationFactory } from '@dispatch/web/ui';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from 'react-router-dom';
import { useCurrentUser } from '@dispatch/web/auth';

const baseTaskGroup: TaskGroup = {
  id: '',
  name: '',
  description: '',
  tenantId: '',
  accessList: [],
  dispatchMethod: 'Optimized',
  dispatchConfigurations: [],
  userIds: [],
  deactivatedAt: null,
};

const TaskGroupCreatePage = () => {
  const { permissions } = usePermissions();
  const { tenantId } = useCurrentUser();
  const navigate = useNavigate();
  const taskGroupId = uuidv4();
  const { notifySuccess } = useNotificationMutationFactory(
    'Task Group',
    'create'
  );
  const onSuccess = () => {
    notifySuccess();
    navigate(`/admin/task-groups/${taskGroupId}`);
  };

  const { upsertTaskGroup, status: mutateStatus } = useUpsertTaskGroup(
    taskGroupId,
    onSuccess
  );

  const handleSave = (value: TaskGroup) => {
    value.id = taskGroupId;
    value.tenantId = tenantId || '';
    upsertTaskGroup(value);
  };

  const statuses = () => {
    if (mutateStatus === 'loading') {
      return mutateStatus;
    }

    return 'success';
  };

  return (
    <TaskGroupDetails
      onSave={handleSave}
      status={statuses()}
      data={baseTaskGroup}
      permissions={permissions}
    />
  );
};

export default TaskGroupCreatePage;
